import gql from 'graphql-tag'

export default gql`mutation phxUserImport($import_users: [ImportUser]) {
	phxUserImport(import_users: $import_users) {
		id
    name
  }
}`
